(function ($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfFieldAddress', ['AddressModel', 'thfFieldHelper', '$sce', function (AddressModel, thfFieldHelper, $sce) {
        var link = function (scope, el) {
            scope.isValid = thfFieldHelper.isValid;
            scope.labelIdentifier = thfFieldHelper.formLabelIdentifier();
            scope.addressDisplay = '';
            scope.tooltip = $sce.trustAsHtml((typeof scope.field.tooltip !== 'undefined') ? scope.field.tooltip : '');

            scope.lastKeyPressed = 0;
            scope.preventLengthyPaste = function(event) {
                if(typeof scope.field.maxLength === 'undefined') {
                    return true;
                }
                
                scope.lastKeyPressed = event.keyCode;
                
                var value = event.target.value;
                if(scope.lastKeyPressed != 8 && scope.lastKeyPressed != 46) {
                    scope.model[scope.field.name] = value.substring(0, scope.field.maxLength);
                }
            }
            
            scope.valid = {
                show: false,
                icon: scope.formState.icon.tick
            };

            var updateDisplayAddress = true;
            var resetValidation = true;
            scope.$watch('addressDisplay', function() {
                if( resetValidation ) {
                    scope.valid.show = false;
                    scope.formState.validation[scope.field.name] = false;
                }
            });
            scope.$watch('model.'+scope.field.name, function() {
                if( updateDisplayAddress ) {
                    if( typeof scope.model[scope.field.name].DPID !== 'undefined' ) {
                        resetValidation = false;
                        scope.addressDisplay = scope.model[scope.field.name].AddressLine+','
                            +scope.model[scope.field.name].Locality+','
                            +scope.model[scope.field.name].State+','
                            +scope.model[scope.field.name].Postcode;

                        setTimeout(function() {
                            resetValidation = true;
                        }, 300);

                        scope.formState.validation[scope.field.name] = true;
                        scope.valid.show = true;
                        scope.valid.icon = scope.formState.icon.tick;
                    }
                    else {
                        scope.addressDisplay = '';
                        scope.formState.validation[scope.field.name] = false;
                    }
                }
            });

            scope.autocompleteOptions = {
                noResults: false,
                isLoading: false,
                getItems: function ($viewValue) {
                    scope.valid.show = false;
                    scope.formState.validation[scope.field.name] = false;

                    return AddressModel.lookup($viewValue).then(
                        function (response) {
                            if (response.result) {
                                return response.content;
                            }
                            else {
                                return [];
                            }
                        });
                },
                onSelect: function ($item, $model, $label, $event) {
                    if ($item.value) {
                        AddressModel.retrieve($item.value).then(function (response) {
                            updateDisplayAddress = false;
                            if( response.result ) {
                                var oldValue = angular.copy(scope.model[scope.field.name]);
                                scope.model[scope.field.name] = response.content;
                                scope.formState.validation[scope.field.name] = true;
                                scope.valid.show = true;
                                scope.valid.icon = scope.formState.icon.tick;

                                if( typeof scope.field.onChange === 'function' ) {
                                    scope.field.onChange.apply(null, [scope.model[scope.field.name], oldValue, scope.model, scope.formModel, scope.field, scope.formField]);
                                }
                            }
                            else {
                                scope.formState.validation[scope.field.name] = false;
                                scope.valid.show = true;
                                scope.valid.icon = scope.formState.icon.invalid;
                            }

                            setTimeout(function() {
                                updateDisplayAddress = true;
                            }, 300);
                        });
                    }
                }
            };
        };
        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
                'formState': '=',
                'formField': '=',
                'formModel': '=',
                'field': '=',
                'validation': '=',
                'model': '=',
                'fieldActions': '=',
                'validationRules': '='
            },
            'link': link,
            'templateUrl': function() {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/fields/address.html');
            }
        };
    }]);
})(jQuery, angular, window);
